import { memo, Suspense, useState } from 'react';
import { useDispatch } from 'react-redux';
import useFetchPublicNotes from '../../hooks/notes/useFetchPublicNotes';
import { setSelectedNoteAction } from '../../redux/actions/notesActions';
import CommonLoader from '../shared/loaders/CommonLoader';
import EmptyContent from '../shared/table/EmptyContent';
import PreviewNoteModal from './modals/PreviewNoteModal';
import NotesTable from './NotesTable';

const PublicNotesList = () => {
  const dispatch = useDispatch();
  const { loading, publicNotes } = useFetchPublicNotes();
  const [showPreviewNoteModal, setShowPreviewNoteModal] = useState(false);

  const handleNoteClick = (note) => {
    dispatch(setSelectedNoteAction(note));
    setShowPreviewNoteModal(true);
  };

  return (
    <Suspense fallback={<CommonLoader />}>
      <div className="flex flex-col items-center">
        {showPreviewNoteModal && <PreviewNoteModal onModalClose={() => setShowPreviewNoteModal(false)} />}
        <NotesTable
          onNoteClick={handleNoteClick}
          onNoteDeleteClick={() => {}}
          notes={publicNotes}
          readOnly={true}
          loading={loading}
          isPublic={true}
        />
        {publicNotes.length === 0 && !loading && <EmptyContent title={'Список публічних нотаток порожній'} />}
      </div>
    </Suspense>
  );
};

export default memo(PublicNotesList);
